export const availableYear = (year: number, yearList: string[]): string => {
  const years = yearList.map(_year => parseInt(_year))
  const thisYear = new Date().getFullYear()
  return years.includes(year) ? year.toString() : Math.min(years.sort().reverse()[0], thisYear)?.toString()
}